import React from "react";
import { Link } from "react-router-dom";
import { MdSupportAgent, MdHelpOutline } from "react-icons/md";
import Banner from "./pages/components/Banner";
import Descriptions from "./pages/components/Descriptions";
import ClassSection from "./pages/components/ClassSection";

export default function Home(props) {
	return (
		<>
			<div className="home-page">
				<Banner />
				<Descriptions />
				<ClassSection />
				<section className="lp-section">
					<div className="container">
						<div className="lp-cta">
							<div>
								<h2 className="lp-cta-title">Need help with your accommodation?</h2>
								<p className="lp-cta-text">
									Reach the Directorate of Student Affairs, counselling, chaplaincy and
									emergency services from the Help Desk.
								</p>
							</div>
							<div className="lp-cta-actions">
								<Link to="/help-desk" className="lp-btn lp-btn--light">
									<MdSupportAgent /> Help Desk
								</Link>
								<Link to="/faqs" className="lp-btn lp-btn--outline-light">
									<MdHelpOutline /> FAQs
								</Link>
							</div>
						</div>
					</div>
				</section>
			</div>
		</>
	);
}
